var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () { return ({
    form: {
        width: '100%'
    }
}); });
export var FormFieldsContext = React.createContext({});
export var MyForm = React.memo(function (_a) {
    var children = _a.children, context = _a.context;
    var classes = useStyles();
    return (_jsx(FormFieldsContext.Provider, __assign({ value: context }, { children: _jsx("form", __assign({ className: classes.form, onSubmit: context.handleSubmit, onReset: context.handleReset }, { children: children }), void 0) }), void 0));
});
